<template>
  <TemplatePage
    :seo-title="get_seoPage.title"
    :seo-description="get_seoPage.description"
    twitter-img-url="/img/seo/lobby/slots-games_1200_1200.jpg"
    og-img-url="/img/seo/lobby/slots-games_1200_630.jpg"
    :is-bread-top="false"
    :is-error="!get_subsectionItem.data && get_subsectionItem.error"
    class="template-games"
  >
    <SkeletonExpandList
      v-if="get_subsectionItem.isLoading && !get_subsectionItem.data"
      :items="15"
    />

    <ExpandList
      v-else
      :key="$route.params[$options.static.PARAM_SUB_PAGE]"
      :query-key="$route.params[$options.static.PARAM_SUB_PAGE]"
      :fetch-method="fetch_subsectionItem"
      :param-page="$route.params[$options.static.PARAM_SUB_PAGE]"
      :list-type="$options.static.LIST_TYPE.GAME.NAME"
      :prop-data="get_subsectionItem.data"
      is-auto-pagination
    >
      <template v-if="headlineInfo && !isHideHeadline">
        <HeadlineAction
          :title="headlineInfo.title"
          :img="headlineInfo.img"
          class="template-games__header"
        />
      </template>
    </ExpandList>
  </TemplatePage>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ExpandList from '~/components/Lobby/ExpandList'
import TemplatePage from '~/components/Base/TemplatePage'
import HeadlineAction from '@/components/shared/HeadlineAction'
import SkeletonExpandList from '~/components/Lobby/Skeletons/SkeletonExpandList'
import { PARAM_SUB_PAGE, PARAM_PAGE, LIST_TYPE, QUERY } from '@/components/Lobby/enum.js'
import { getLangText } from '@/components/Lobby/helpers.js'

export default {
  name: 'TemplateGames',
  components: {
    ExpandList,
    HeadlineAction,
    TemplatePage,
    SkeletonExpandList,
  },
  static: {
    PARAM_SUB_PAGE,
    LIST_TYPE,
  },
  async fetch() {
    await this.fetch_subsectionItem({ term: this.$route.params[PARAM_SUB_PAGE], take: 20 })

    const data = this.get_subsectionItem.data

    if (!data) {
      return
    }
  },
  head() {
    const isHasQueryPage = this.$route.query[`${QUERY.PAGE}_${this.$route.params[PARAM_SUB_PAGE]}`]
    if (isHasQueryPage) {
      return {
        meta: [{ name: 'robots', content: 'noindex, follow' }],
      }
    }
  },
  computed: {
    ...mapGetters('lobby', ['get_currentSection', 'get_subsectionItem']),
    ...mapGetters('seo', ['get_seoPage']),
    headlineInfo() {
      const data = this.get_subsectionItem.data

      return {
        title: data ? getLangText(data.nameUa, data.nameUa, this.$i18n) : '',
        link: data ? this.localePath(`/${this.$route.params[PARAM_PAGE]}`) : '',
        img: data ? `${this.$config.cloudUrl}${data.iconUrl}` : '',
      }
    },
    currentSection() {
      return this.get_currentSection(this.$route)
    },
    isHideHeadline() {
      return this.currentSection?.subsections?.find(f => this.$route.params[PARAM_SUB_PAGE].includes(f.term))
    },

  },
  destroyed() {
    this.reset_subsectionItem()
  },
  methods: {
    ...mapActions('lobby', [
      'fetch_subsectionItem',
      'reset_subsectionItem',
    ]),
  },
}
</script>

<style lang="scss" scoped>
.template-games {
  padding-top: 0!important;

  &__header {
    margin-bottom: 16px;

    @include media(tablet) {
      margin-bottom: 24px;
    }
  }
}
</style>
